import React, { ReactNode } from "react";
import { useIsSmallScreen } from "../App";

export const Padding: React.FC<{ onlySides?: boolean; children: ReactNode }> = (
    props
) => {
    const { onlySides, children } = props;

    const isSmallScreen = useIsSmallScreen();

    const padding = isSmallScreen ? 8 : 48;
    return (
        <div
            style={
                onlySides
                    ? { paddingLeft: padding, paddingRight: padding }
                    : {
                          padding: padding,
                      }
            }
        >
            {children}
        </div>
    );
};
